import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { useSelector } from 'react-redux';
import ProfileSettingsNavTabs from '../../../common/navigationTabs/ProfileSettingsNavTabs/ProfileSettingsNavTabs';
import ReferralsInfoBlurb from '../../../referrals/ReferralsInfoBlurb/ReferralsInfoBlurb';
import ReferralsView from '../../../referrals/ReferralsView/ReferralsView';
import envConfig from '../../../../envConfig';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import RaaAuthenticatedRemoteService from '../../../../utility/RaaAuthenticatedRemoteService';

function ReferralsPage({ countryList }) {
  const { userId, referralsEnabled } = useSelector(selectSessionInformation);
  const [referralCode, setReferralCode] = useState('');
  const [rewardsBalance, setRewardsBalance] = useState(0);
  const [referralAddress, setReferralAddress] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [noAddressForUser, setNoAddressForUser] = useState(false);

  const handleFetchUserReferralData = async () => {
    const referralViewPromise = RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/referral/view/${userId}`);
    const referralAddressPromise = RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/referral/find-mailing-address-by-user-id/${userId}`);
    const promises = [
      referralViewPromise,
      referralAddressPromise,
    ];
    const res = await Promise.allSettled(promises);
    const viewResponse = res[0];
    const addressResponse = res[1];
    if (viewResponse.status === 'fulfilled') {
      setReferralCode(viewResponse.value.referralView.referralCode);
      setRewardsBalance(viewResponse.value.referralView.availableRewardsBalance);
    } else {
      setLoadError(true);
    }
    if (addressResponse.status === 'fulfilled' && addressResponse.value.mailingAddress) {
      setReferralAddress(addressResponse.value.mailingAddress);
    } else {
      setNoAddressForUser(true);
    }
    setIsLoading(false);
  };
  React.useEffect(() => {
    if (referralsEnabled) {
      handleFetchUserReferralData().then(() => { });
    } else {
      window.location.href = '/user';
    }
  }, []);

  if (loadError) {
  /* istanbul ignore next */
    return (
      <>
        <ProfileSettingsNavTabs />
        <ReferralsInfoBlurb />
        <div className="clearfix text-right my-3">
          <h5 className="float-left">Recommend Room Alert. Earn Rewards.</h5>
        </div>
        <div className="row">
          <div className="col">
            <ErrorBanner onCloseError={() => setLoadError(false)}>
              Unexpected Error.
            </ErrorBanner>
          </div>
        </div>
      </>
    );
  }

  /* istanbul ignore next */
  return (
    <>
      <ProfileSettingsNavTabs />
      <ReferralsInfoBlurb />
      <div className="clearfix text-right mt-3 mb-4">
        <h5 className="float-left">Recommend Room Alert. Earn Rewards.</h5>
      </div>
      {isLoading ? (
        <div className="row d-flex justify-content-center mt-5">
          <div>
            <ProgressSpinner />
          </div>
        </div>
      )
        : (
          <ReferralsView
            referralCode={referralCode}
            rewardsBalance={rewardsBalance}
            referralAddress={referralAddress}
            countryList={countryList}
            setReferralCode={setReferralCode}
            userId={userId}
            noAddressForUser={noAddressForUser}
          />
        )}
    </>
  );
}

ReferralsPage.propTypes = {
  countryList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    crmId: PropTypes.number,
    code: PropTypes.number,
    name: PropTypes.string,
    abbreviation: PropTypes.string,
  })).isRequired,
};

export default ReferralsPage;
